module.exports = __webpack_public_path__ + "static/muji-0f3ad3d8eada849fb4c8f485a696c051.png";